/**
 * Global Imports
*/

import React, { useState } from 'react';

/**
 * Local Imports
*/

import { GuestRouter } from '../../Routers/Guest';

/**
 * Exports
*/

export const LayoutContext = React.createContext({
  isBusy: false
});

export function GuestLayout(props) {
  /** States **/
  
  const [ isBusy, setIsBusy ] = useState(false);
  
  /** Output **/
  
  return (
    <LayoutContext.Provider value={{ isBusy, setIsBusy }}>
      <div className='flex justify-center h-full bg-gray-600'>
        <div className='flex flex-col justify-center w-full md:w-1/3 xl:w-1/4'>
          <div className='p-4 rounded-md bg-white shadow'>
            <h1 className='mb-4 text-3xl text-center text-gray-500 font-bold'>
              { process.env.MIX_APP_NAME } Admin
            </h1>
            <GuestRouter />
          </div>
        </div>
      </div>
    </LayoutContext.Provider>
  );
}